export const shouldWaitForCheckoutUrl = (needsPayment, checkoutUrl) => {
  return needsPayment && !checkoutUrl
}

export const shouldWaitForReturnLabels = (
  hasCarrierConnected,
  returnLabels,
  requestedReturnLabels,
  disableReturnLabelDelay
) => {
  return !disableReturnLabelDelay && hasCarrierConnected && returnLabels?.length !== requestedReturnLabels
}
